export default __webpack_public_path__ + "static/media/cone_peak_thumb.a53914a3.jpeg";